
import "../styles/ProjectStyle.css"
import { Link } from 'react-router-dom'
export default function ProjectContainer(props) {

    return (
        <>
            <div className='projectitem' >

                <div className='projectdescription'>
                    <div className='projectname'>
                        {props.title}
                    </div>
                    <div className='aboutthatproject' >
                        <div className='summary'>
                            {props.summary}
                            <div className='projectlinks'>
                                <Link className="projectlink" to={props.link} target='_blank'>{props.link}</Link>
                            </div>
                        </div>
                    </div>

                </div>
                <div className='imageview' >
                    <Link id="link-image" to={props.imageurl} target='_blank'><img className="image" src={props.imageurl} alt={`${props.title}`} /></Link>
                </div>
            </div>
        </>
    )
}
